import blog1 from "../../Images/blog.png";
import blog2 from "../../Images/blog-2.png";
import blog3 from "../../Images/blog-3.png";
import blog4 from "../../Images/blog-4.png";
import blog5 from "../../Images/blog-5.png";
import blog6 from "../../Images/blog-6.png";
import blog7 from "../../Images/blog-7.png";
import blog8 from "../../Images/blog-8.png";
import blog9 from "../../Images/blog-9.png";
import bloglist1 from "../../Images/blog-list-1.png"
import bloglist2 from "../../Images/blog-list-2.png"
import bloglist3 from "../../Images/blog-list-3.png"
import bloglist4 from "../../Images/blog-list-4.png"
import blogAuthor1 from "../../Images/blog-writer-1.png"
import blogAuthor2 from "../../Images/blog-writer-2.png"
import blogAuthor3 from "../../Images/blog-writer-3.png"
import blogAuthor4 from "../../Images/blog-writer-4.png"
import whtArrow from "../../Images/white-arrow.png";


export const BlogData = [
  {
    id: 1,
    name: "Why Does My Car Heater Blow Cold Air?",
    img: blog1,
    img2 : bloglist1,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
    para : " Lorem ipsum doller sit amet aute irure velits an reprehender voluptate velit fugiat nulla pariatur exce doloe amet. ",
    writterImg : blogAuthor1,
    writterName : "Ronda Racol"

  },
  {
    id: 2,
    name: "How do you know when to change your tires?",
    img: blog2,
    img2 : bloglist2,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
    para : " Lorem ipsum doller sit amet aute irure velits an reprehender voluptate velit fugiat nulla pariatur exce doloe amet. ",
    writterImg : blogAuthor2,
    writterName : "Priyanka padikal"
  },
  {
    id: 3,
    name: "Avoid New Car Prices: Take Care of Car You Already Own",
    img: blog3,
    img2 : bloglist3,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
    para : " Lorem ipsum doller sit amet aute irure velits an reprehender voluptate velit fugiat nulla pariatur exce doloe amet. ",
    writterImg : blogAuthor3,
    writterName : "Monaj Devid"
  },
  {
    id: 4,
    name: "5s process mainteain in store",
    img: blog4,
    img2 : bloglist4,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
    para : " Lorem ipsum doller sit amet aute irure velits an reprehender voluptate velit fugiat nulla pariatur exce doloe amet. ",
    writterImg : blogAuthor4,
    writterName : "Hitesh Sins"
  },
  {
    id: 5,
    name: "Schedully replacement of all belts",
    img: blog5,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
  },{
    id: 6,
    name: "Proper Mainteanance of engine",
    img: blog6,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
  },
  {
    id: 7,
    name: "Proper Repalcement of Turbocharger",
    img: blog7,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
  },
  {
    id: 8,
    name: "Schedully tighting of engine mounting",
    img: blog8,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
  },
  {
    id: 9,
    name: "Leafing process of vehicle",
    img: blog9,
    title: "Auto Repair",
    date: "25, December, 2022",
    arrow: whtArrow,
  },
];
